export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  errorMessage: "login-error-message",
  logoutButton: "logout-button",
};
